/**
 * This file is a place to put app-level constants which will be used throughout the app. Putting constants in here
 * makes it easy to change application behavior by simply modifying the constants' values.
 */


// 2022-03-02 Tyler: As of the time of this comment, the "Cook'n by DVO" Facebook app does not have the
// "user_friends" permission. I made several fixes & improvements to the My Friends page which we want to release
// as soon as possible without waiting for Facebook to approve "user_friends" permission. So for now, we will
// display a "Coming Soon!" message. 'isFacebookFriendsEnabled' is here to easily turn on Facebook Friends
// functionality when Facebook approves the "user_friends" permission.
export const IS_FACEBOOK_FRIENDS_ENABLED = true

// The ID of the Facebook App we communicate with.
export const FACEBOOK_APP_ID = "2608122946124853" // PROD - "Cook'n by DVO"
// export const FACEBOOK_APP_ID = "1041221153127974" // TESTING - "Cook'n by DVO - Test1"

// Facebook button image urls
export const FACEBOOK_LOGIN_BUTTON_IMAGE_URL = "https://www.dvo.com/cookn/assets/img/facebook-login-button.png"
export const FACEBOOK_LOGOUT_BUTTON_IMAGE_URL = "https://www.dvo.com/cookn/assets/img/facebook-logout-button.png"


// WEBPACK FOOTER //
// ./src/Helpers/constants.js